import { defineStore } from "pinia";
import { computed, nextTick, reactive, watch } from "vue";
import { StorageHelper } from "@/utils/StorageHelper";
import { StorageName } from "@/utils/StorageHelper/constants";

export const useProductSearchPaginationStore = defineStore("productSearchPaginationStore", () => {
    const initialPaginationData = {
        pageFrom: 0,
        pageSize: 10,
        totalCount: 0,
        currentPage: 1,
    };

    const {
        write,
        read
    } = new StorageHelper(StorageName.ProductSearchPaginationStore);

    const paginationData = reactive(Object.create(initialPaginationData));
    const pageCount = computed(() => Math.ceil(paginationData.totalCount / paginationData.pageSize));

    const setTotalCount = (count: number) => {
        paginationData.totalCount = count;
    };

    const changePage = (page: number) => {
        paginationData.pageFrom = (page - 1) * paginationData.pageSize;
        paginationData.currentPage = page;
    };

    const resetPage = () => {
        paginationData.currentPage = 1;
        paginationData.pageFrom = 0;
    };

    const reset = async () => {
        Object.assign(paginationData, initialPaginationData);
        resetPage();

        await nextTick();

        return Promise.resolve();
    };

    const initialize = async () => {
        const storedPaginationData = read();

        if (!storedPaginationData) return;

        Object.assign(paginationData, storedPaginationData);

        return Promise.resolve();
    };


    watch(paginationData, () => {
        write(paginationData);
    }, { deep: true });

    return {
        paginationData,
        changePage,
        resetPage,
        reset,
        setTotalCount,
        pageCount,
        initialize
    };
});